import { createAction } from "../fns/createAction";
import { fns, libTypes } from "@holta/lib";
import toast, { Toaster } from 'react-hot-toast';

export const setDeliveryOrders = createAction("SET_DELIVERY_ORDERS", (newState, orders: libTypes.Order[]) => {
    newState.deliveryOrders = fns.orders.filterActiveOrders(orders);
});
